import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import unidadesSTI from "../../../../../constants/unidadesSTI";
import Select from "../../Relatorio1/Select";
import Radio from "../../Relatorio1/Radio";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import utils from "../../../../../utils/utilsProducaoSTI";
import AnualV3 from "../Anual_v3";
import Grafico from "../../Grafico";
import TabelaADN from "../TabelaADN";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes",
            meses: ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
        }
    }

    async componentDidMount() {
        await this.getDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevState.isAcumulado !== this.state.isAcumulado) {
            await this.getDados();
        }
    }

    getDados = async (isAcumulado) => {

        let url = this.state.isAcumulado ? "/sti/consulta?tipo=acumulado" : "/sti/consulta?tipo=mes";
        let dados = await api.get(url);
        dados = dados.data.dados;
        
        let metas = await (await api.get("/sti/metas")).data.metas;
        
        this.setState({ dados, metas });

    }

    selectMes = (event) => {
        this.setState({ mesSelecionado: event.target.value })
    }

    onChange = async (event) => {
        let isAcumulado = event.target.value === "acumulado" ? true : false;
        this.setState({ isAcumulado, radioChecked: event.target.value })
    }

    identificaLinhadeAtuacao = (categoria) => {

        let linha;
        switch(categoria) {
            case "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos":
            case "Consultoria em Processos Produtivos":
                linha = "Consultoria em Tecnologia";
                break;
            case "Calibração":
            case "Ensaios":
                linha = "Metrologia";
                break;
            case "Pesquisa, Desenvolvimento e Inovação de Produto":
            case "Pesquisa, Desenvolvimento e Inovação de Processo":
                linha = "Pesquisa, Desenvolvimento e Inovação";
                break;
            case "Consultoria em Gestão Empresarial":
                linha = "Serviços Complementares";
                break;
            case "Serviços Operacionais":
                linha = "Serviços Técnicos Especializados";
                break;

        }
        
        return linha;

    }

    formataJSONcomSomatorio = () => {

        let dados = JSON.parse(JSON.stringify(this.state.dados));
        let novosDados = JSON.parse(JSON.stringify(dados));

        Object.keys(dados).map((mes, i) => {
            
            dados[mes].map((unidade, j) => {

                let t = novosDados[mes][novosDados[mes].findIndex((v) => v.unidade === unidade.unidade)];
                
                Object.keys(unidade.modalidades).map((categoria, k) => {
                    
                    let linha = this.identificaLinhadeAtuacao(categoria);
                    
                    if(!t.modalidades.hasOwnProperty(linha)) {
                        t.modalidades[linha] = unidade.modalidades[categoria];
                    }
                    else {
                        Object.keys(t.modalidades[linha]).map((indicador, ind) => {
                            t.modalidades[linha][indicador] += unidade.modalidades[categoria][indicador];
                        })
                    }

                });

            });

        });

        return novosDados;

    }

    // ************* Metas **************** //

    groupBy = (objectArray, property) => {
        return objectArray.reduce(function (acc, obj) {
            var key = obj[property];
            if (!acc[key]) {
            acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }

    calculaMetas = () => {

        let { metas, dados } = this.state;
        if(!metas) return;
        let groupBySigla = this.groupBy(metas, "Sigla");

        // adiciona DR
        groupBySigla["DR"] = JSON.parse(JSON.stringify(metas));

        let vetor = [];

        Object.keys(groupBySigla).forEach(( sigla, ind1 ) => {
            
            // Agrupa por NomeNivel5
            let groupByNomeNivel5 = this.groupBy(groupBySigla[sigla], "NomeNivel5");
            // Agrupa por linhaAtuacao
            let groupByLinhaAtuacao = this.groupBy(groupBySigla[sigla], "linhaAtuacao");
            // concatena NomeNivel5 e linhaAtuacao
            groupByNomeNivel5 = { ...groupByNomeNivel5, ...groupByLinhaAtuacao }

            let objModalidades = {}
            
            Object.keys(groupByNomeNivel5).forEach(( categoria, ind2 ) => {

                let numeroAtendimento = new Array(12).fill(0);
                let horasTecnicas     = new Array(12).fill(0);
                let ensaios           = new Array(12).fill(0);
                let calibracoes       = new Array(12).fill(0);
                let relatoriosELaudos = new Array(12).fill(0);
                let receita           = new Array(12).fill(0);
                let despesa           = new Array(12).fill(0);
                
                groupByNomeNivel5[categoria].forEach((indicador, ind3 ) => {
                    indicador.numeroAtendimento.forEach((valor, i) => numeroAtendimento[i] += valor );
                    indicador.horasTecnicas.forEach((valor, i)     => horasTecnicas[i] += valor );
                    indicador.ensaios.forEach((valor, i)           => ensaios[i] += valor );
                    indicador.calibracoes.forEach((valor, i)       => calibracoes[i] += valor );
                    indicador.relatoriosELaudos.forEach((valor, i) => relatoriosELaudos[i] += valor );
                    indicador.receita.forEach((valor, i)           => receita[i] += valor );
                    indicador.despesa.forEach((valor, i)           => despesa[i] += valor );
                });

                objModalidades[categoria] = { numeroAtendimento, horasTecnicas, ensaios, calibracoes, relatoriosELaudos, receita, despesa }

            });
            
            sigla = unidadesSTI.parseNomeLongoSTI(sigla);

            vetor.push({
                unidade: sigla,
                modalidades: objModalidades
            });

        });
        
        return vetor;

    }

    // formatar json do realizado para ficar igual a meta
    transformaJSONRealizados = (dados, meses) => {

        let realizados = dados;
        // cria novo objeto vazio
        let obj = {}

        // constroi no json formatado com valores zerados
        // itera sobre o array de 12 meses
        Object.keys(realizados).map((mes, i) => {
            // intera sobre o array das unidades
            realizados[mes].map((unidade, j) => {
                // verifica se o novo objeto (obj) possui a propriedade da unidade
                let nomeUnidade = unidade.unidade;
                // se não existir a propriedade, adiciona uma propridade modalidade vazia
                if(!obj.hasOwnProperty(nomeUnidade)) {
                    obj[nomeUnidade] = { unidade: nomeUnidade, modalidades: {} }
                    Object.keys(unidade.modalidades).map((categoria, k) => {
                        
                        if(!obj[nomeUnidade].modalidades.hasOwnProperty(categoria)) {
                            let objindicadores = {
                                calibracoes:       new Array(12).fill(0),
                                ensaios:           new Array(12).fill(0),
                                horasTecnicas:     new Array(12).fill(0),
                                numeroAtendimento: new Array(12).fill(0),
                                relatoriosELaudos: new Array(12).fill(0)
                            }
                            obj[nomeUnidade].modalidades[categoria] = objindicadores;
                        }
                    });
                }
            });
        });

        // itera sobre o array e preenche os valores mensais
        Object.keys(realizados).map((mes, i) => {
            realizados[mes].map((unidade, j) => {
                let nomeUnidade = unidade.unidade;
                Object.keys(unidade.modalidades).map((categoria, k) => {
                    Object.keys(unidade.modalidades[categoria]).map((indicador, l) => {
                        try {
                            obj[nomeUnidade].modalidades[categoria][indicador][meses.indexOf(mes)] = unidade.modalidades[categoria][indicador]
                        } catch (error) {
                        }
                    });
                });
            });
        });

        return obj;

    }

    calculaAcumulado = (metas, reverse=false) => {
        if(!metas) return
        let acumulado = metas.map((unidade) => {
            let modalidades = {}
            Object.keys(unidade.modalidades).map((modalidade) => {
                let colunas = {}
                Object.keys(unidade.modalidades[modalidade]).map((valor) => {
                    let dados = unidade.modalidades[modalidade][valor].map((valorMensal, i) => {
                        let valorMes = 0;
                        if(i === 0) valorMes = valorMensal;
                        else {
                            let valores = unidade.modalidades[modalidade][valor];
                            if(reverse) {
                                valorMes = valores[i] === 0 ? 0 : valores[i] - valores[i-1]
                            }
                            else {
                                valorMes = valores.slice(0, i+1).reduce((acc, atual) => acc + atual, 0);
                            }
                        }
                        return valorMes;
                    });
                    colunas[valor] = dados;
                })
                modalidades[modalidade] = colunas;
            })
            return { unidade: unidade.unidade, modalidades }
        })
        return acumulado;
    }

    renderDados = () => {

        let metas = this.calculaMetas();
        let { dados, mesSelecionado, radioChecked, isAcumulado, meses } = this.state;
        
        dados = this.formataJSONcomSomatorio();
        let dadosTransformados = this.transformaJSONRealizados(dados, meses)

        // Array de unidades
        let dadosTransformadosArray = Object.keys(dadosTransformados).map((unidade) => {
            return dadosTransformados[unidade];
        });

        if(isAcumulado) {
            metas = this.calculaAcumulado(metas);
        }
        else {
            dadosTransformadosArray = this.calculaAcumulado(dadosTransformadosArray, true);
        }
 
        return { metas, dados, meses, dadosTransformados, dadosTransformadosArray }

    }

    verificaUltimoMesApurado = (dados, mesSelecionado, meses) => {
        let mesesApurados = Object.keys(dados);
        if(mesesApurados.length === 0) {
            // Nenhuma planilha foi apurada ainda: não há mês "último apurado",
            // mantém o mês selecionado para exibir o relatório zerado.
            return mesSelecionado
        }
        if(mesesApurados.includes(mesSelecionado)) {
            return mesSelecionado
        }
        else {
            let arraySort = mesesApurados.sort((a, b) => {
                if(meses.indexOf(a) < meses.indexOf(b)) return -1
                else return 1
            });
            return mesesApurados[arraySort.length-1]
        }
    }

    render() {

        let { mesSelecionado, radioChecked, isAcumulado, meses} = this.state;
        let { metas, dados, dadosTransformados, dadosTransformadosArray } = this.renderDados();

        let ultimoMesApurado = this.verificaUltimoMesApurado(dados, mesSelecionado, meses);

        return (
            <Fragment>

                <div className="card">
                    <div className="card-header">
                        Opções
                    </div>
                    <div className="card-body">

                        <Select selectMes={this.selectMes} selecionado={mesSelecionado} />
                        <Radio onChange={this.onChange} radioChecked={radioChecked} />
                        {/* <Link to={location => (
                            {
                                ...location,
                                pathname: `/upload`,
                                anterior: window.location.pathname || "/unidade",
                            }
                        )}>
                            <button className="btn btn-primary mt-3">Upload</button>
                        </Link> */}

                    </div>
                </div>

                <div className="mt-5">
                    <Tabs defaultActiveKey={"DR"}>

                        {/* As abas vêm das metas (sempre existem), não do realizado apurado —
                            assim o relatório aparece com Meta preenchida e Realizado zerado
                            mesmo quando nenhuma planilha de produção foi enviada ainda. */}
                        {metas && metas.map((meta, i) => {

                            let sigla = meta.unidade;

                            if(sigla === 'IST SENAI em Tecnologia em Automação Industrial') return null;

                            return (
                                <Tab eventKey={sigla} title={sigla}>

                                    <Fragment>

                                        <TabelaADN valor={dadosTransformadosArray} meta={metas} mesSelecionado={mesSelecionado} meses={meses} unidade={sigla} isAcumulado={isAcumulado} ultimoMesApurado={ultimoMesApurado} />

                                        <AnualV3 unidade={sigla} realizados={dadosTransformadosArray} metas={metas} isAcumulado={isAcumulado} />

                                        <Grafico unidade={sigla} realizados={dadosTransformadosArray} metas={metas} />

                                    </Fragment>

                                </Tab>
                            )
                        })}

                    </Tabs>
                </div>

            </Fragment>
        )
    }
}